import React from "react";
import Chart from "react-apexcharts";
import "../InsightMenu/InsightPreview.scss";
import CultureMap from "../../../assets/images/cultural-map.png";

const CultureMapPreview = () => {
    const series = [
        {
            name: "CSAT-V3",
            data: [
                { x: "OVERALL", y: 65 },
                { x: "Male", y: 67 },
                { x: "Female", y: 52 },
                { x: "Other", y: 48 },
                { x: "IT", y: 78 }
            ]
        },
        {
            name: "Engagement",
            data: [
                { x: "OVERALL", y: 60 },
                { x: "Male", y: 62 },
                { x: "Female", y: 55 },
                { x: "Other", y: 50 },
                { x: "IT", y: 80 }
            ]
        },
        {
            name: "Leadership",
            data: [
                { x: "OVERALL", y: 58 },
                { x: "Male", y: 61 },
                { x: "Female", y: 49 },
                { x: "Other", y: 45 },
                { x: "IT", y: 85 }
            ]
        },
        {
            name: "Work Culture",
            data: [
                { x: "OVERALL", y: 63 },
                { x: "Male", y: 66 },
                { x: "Female", y: 54 },
                { x: "Other", y: 51 },
                { x: "IT", y: 88 }
            ]
        }
    ];

    const options = {
        chart: {
            type: "heatmap",
            toolbar: { show: false }
        },
        plotOptions: {
            heatmap: {
                radius: 2,
                enableShades: false,
                colorScale: {
                    ranges: [
                        { from: -1, to: -1, color: "#d1d5db", name: "NA" },
                        { from: 0, to: 10, color: "#ff3b3b" },
                        { from: 10, to: 20, color: "#ff5c5c" },
                        { from: 20, to: 30, color: "#ff7b7b" },
                        { from: 30, to: 40, color: "#ffd966" },
                        { from: 40, to: 50, color: "#facc15" },
                        { from: 50, to: 60, color: "#fbbf24" },
                        { from: 60, to: 70, color: "#f59e0b" },
                        { from: 70, to: 80, color: "#86efac" },
                        { from: 80, to: 90, color: "#4ade80" },
                        { from: 90, to: 100, color: "#16a34a" }
                    ]
                }
            }
        },
        dataLabels: {
            enabled: true,
            style: {
                colors: ["#111827"],
                fontWeight: 500
            }
        },
        legend: {
            show: true,
            position: 'bottom', // Set the legend position to 'bottom'
            horizontalAlign: 'center', // Align the legend horizontally to the center
            // You can add more styling options here, e.g.,
            // fontSize: '14px',
            // offsetY: 10, // Adjust vertical offset if needed
        },
        xaxis: {
            title: {
                text: "Themes Average"
            }
        },
        tooltip: {
            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
                const value =
                    w.config.series[seriesIndex].data[dataPointIndex].y;
                const label =
                    w.config.series[seriesIndex].data[dataPointIndex].x;

                return `
          <div style="padding:8px">
            <strong>Dimension:</strong> CSAT-V3<br/>
            <strong>Demography:</strong> ${label}<br/>
            <strong>Score:</strong> ${value}
          </div>
        `;
            }
        },
        grid: {
            padding: {
                right: 20
            }
        }
    };

    return (
        <div className="culture-map-preview">
            <img alt="" src={CultureMap} className="w-100" />
            {/* 🔹 Header */}
            {/* <div className="culture-header">
                <h5>Culture Map</h5>

                <div className="culture-controls d-flex justify-content-between">
                    <div>
                        <label>Select Demographic:</label>
                        <select>
                            <option>Department</option>
                        </select>
                    </div>
                    <div className="d-flex">
                        <button className="download-btn me-2">A↕ Theme</button>

                        <button className="download-btn">Download as excel</button>
                    </div>
                </div>
            </div> */}

            {/* 🔹 Heatmap */}
            {/* <div className="culture-map-chart">
                <Chart
                    options={options}
                    series={series}
                    type="heatmap"
                    height={320}
                />
            </div> */}
        </div>
    );
};

export default CultureMapPreview;